import { onBeforeUnmount, onMounted, ref } from 'vue'

const LARGE_SCREEN = 992

export const useMobileView = (largeScreenWith = LARGE_SCREEN) => {
  const isMobileView = ref(false)

  const handleWindowSize = () => {
    isMobileView.value = window.innerWidth < largeScreenWith
  }

  onMounted(() => {
    handleWindowSize()
    window.addEventListener('resize', handleWindowSize)
  })
  onBeforeUnmount(() => {
    window.removeEventListener('resize', handleWindowSize)
  })

  return { isMobileView }
}
